<template>
    <div class="no-content-box">
        <img class="no-content" src="~@/assets/no-content.png" alt="" />
        <div>{{ msg }}</div>
    </div>
</template>

<script>
export default {
    name: "no-content",
    props: ["msg"]
};
</script>

<style lang="scss" scoped src="./no-content.scss">
</style>